import axios from "axios";
import { API_ENDPOINT } from "@/utils/misc";

export const sendMail = (to, message, custom_subject = null, custom_body = null) => {
  return axios.post(
    `${API_ENDPOINT()}/mail-tool/send`, {
      to, message, custom_subject, custom_body
    });
};
